// src/contexts/LocationContext.jsx
// Provides currentLocation and setCurrentLocation to all components
// currentLocation: 'redmond' | 'kirkland' | 'all'

import React, { createContext, useContext, useState } from 'react';

export const LOCATIONS = {
  redmond: { id: 'redmond', label: 'Redmond', short: 'RMD', color: '#3b82f6' },
  kirkland: { id: 'kirkland', label: 'Kirkland', short: 'KRK', color: '#10b981' },
  all: { id: 'all', label: 'All Locations', short: 'ALL', color: '#8b5cf6' },
};

const LocationContext = createContext({
  currentLocation: 'redmond',
  setCurrentLocation: () => {},
  locationLabel: 'Redmond',
  isAll: false,
});

export const LocationProvider = ({ children }) => {
  const [currentLocation, setCurrentLocationState] = useState(() => {
    return localStorage.getItem('stemtree_location') || 'redmond';
  });

  const setCurrentLocation = (loc) => {
    localStorage.setItem('stemtree_location', loc);
    setCurrentLocationState(loc);
  };

  const locationInfo = LOCATIONS[currentLocation] || LOCATIONS.redmond;

  return (
    <LocationContext.Provider value={{
      currentLocation,
      setCurrentLocation,
      locationLabel: locationInfo.label,
      locationColor: locationInfo.color,
      isAll: currentLocation === 'all',
    }}>
      {children}
    </LocationContext.Provider>
  );
};

export const useLocation = () => useContext(LocationContext);

export default LocationContext;
